import mapboxgl from 'mapbox-gl';
import { fetchCoordinateFromMapbox, getCountryCoordinates } from '../utils/countryCoordinates';

export default function () {
    // get all js-partials--map and set id to them
    const maps = document.querySelectorAll('.js-partials--map');
    maps.forEach((map, index) => {
        let containerId = `p-map-${index}`;
        map.setAttribute('id', containerId);
        let isoCodes = map.getAttribute('data-iso-code');
        isoCodes = isoCodes.split(',');
        isoCodes = isoCodes.map((isoCode) => {
            return isoCode.trim();
        });
        initMap(containerId, isoCodes);
    });
}

async function initMap(containerId, isoCodes = []) {
    mapboxgl.accessToken = 'pk.eyJ1IjoidG9tLWVkZmkiLCJhIjoiY21hbnR1emt6MDJvYzJvc2c4Nmd4eW1iNyJ9.GwYZjGDw0JQ3suyPLhPLFg';
    let map = new mapboxgl.Map({
        container: containerId,
        style: 'mapbox://styles/tom-edfi/cmbetzox0004t01scdxdt087m',
        center: [31.2357, 30.04444],
        zoom: 3.5,
        pitch: 0,
        bearing: 0,
        interactive: true,
        scrollZoom: false,
        dragPan: false,
        doubleClickZoom: false,
        dragRotate: false,
    });

    if (isoCodes.length > 0) {
        const normalizedIsoCodes = isoCodes.map((isoCode) => (isoCode || '').trim().toUpperCase()).filter((isoCode) => isoCode.length > 0);

        if (normalizedIsoCodes.length === 0) {
            return;
        }

        const resolvedCoordinates = await Promise.all(
            normalizedIsoCodes.map(async (isoCode) => {
                let coordinate = getCountryCoordinates(isoCode);

                if (!coordinate) {
                    coordinate = await fetchCoordinateFromMapbox(isoCode, mapboxgl.accessToken);
                }

                if (!coordinate) {
                    console.warn(`[partialsMap] Unable to resolve coordinates for ISO code: ${isoCode}`);
                }

                return { isoCode, coordinate };
            }),
        );

        const fillColor = ['case'];
        normalizedIsoCodes.forEach((isoCode) => {
            fillColor.push(['==', ['get', 'iso_3166_1'], isoCode], '#2C59C6');
        });
        fillColor.push('#F7F7F7');

        map.on('load', () => {
            map.addSource('countries', {
                type: 'vector',
                url: 'mapbox://mapbox.country-boundaries-v1',
            });

            map.addLayer({
                id: 'country-fills',
                type: 'fill',
                source: 'countries',
                'source-layer': 'country_boundaries',
                layout: {},
                paint: {
                    'fill-color': fillColor,
                },
            });

            map.addLayer({
                id: 'country-borders',
                type: 'line',
                source: 'countries',
                'source-layer': 'country_boundaries',
                layout: {},
                paint: {
                    'line-color': '#171717',
                    'line-width': 0.01,
                },
            });
        });

        const validCoordinates = resolvedCoordinates.map(({ coordinate }) => coordinate).filter((coordinate) => Array.isArray(coordinate) && coordinate.length === 2);

        if (validCoordinates.length === 1) {
            map.setCenter(validCoordinates[0]);
        } else if (validCoordinates.length > 1) {
            const bounds = validCoordinates.reduce((accumulator, coord) => accumulator.extend(coord), new mapboxgl.LngLatBounds(validCoordinates[0], validCoordinates[0]));

            map.fitBounds(bounds, { padding: 40 });
        }
    }
}
